import { render, staticRenderFns } from "./RouterPassThroughMenuClientApps.vue?vue&type=template&id=6d3f9458&scoped=true&"
import script from "./RouterPassThroughMenuClientApps.vue?vue&type=script&lang=js&"
export * from "./RouterPassThroughMenuClientApps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3f9458",
  null
  
)

export default component.exports